













import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

import { IUser } from '@/common/Auth';

import Brand from '@/services/Brand';

import Welcome from '@/components/Global/Welcome.vue';
import AccountBalance from '@/components/Home/Global/AccountBalances.vue';
import CMEOptions from '@/components/Home/Global/CME.vue';
import CyberSolutions from '@/components/Home/Global/CyberSolutions.vue';
import Notifications from '@/components/Home/Global/Notifications.vue';
import AgentMessage from '@/components/Home/Global/AgentMessage.vue';

@Component({
	name: 'home',
	components: {
		AccountBalance,
		CMEOptions,
		CyberSolutions,
		AgentMessage,
		Notifications,
		Welcome,
	},
})
export default class Dashboard extends Vue {
	@State('user', { namespace: 'Auth' }) private user: IUser | undefined;

	private readonly Brand = Brand;
}
